// ==========================================
// 2. src/components/common/SectionHeader.js
// ==========================================
import React from 'react';

export const SectionHeader = ({ title, subtitle, className = '' }) => (
  <div className={`text-center mb-12 ${className}`}>
    <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2>
    {subtitle && (
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">{subtitle}</p>
    )}
  </div>
);

export default SectionHeader;